module.exports = __webpack_public_path__ + "static/media/GHICL.bf794f6b.jpg";